import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/app/ai-automation/AIAutomationContent.tsx");
